export default function authHeader() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.token ? { 'AUTHORIZATION': user.token } : {};
  } catch {
    return {};
  }
}
